import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Typography, Empty, Button } from 'antd';
import {
  SettingOutlined,
  ArrowLeftOutlined,
  FunnelPlotOutlined,
  InboxOutlined,
  TruckOutlined,
} from '@ant-design/icons';
import { useDashboardNavigation } from '../../contexts/DashboardNavigationContext';
import {
  ProductDemandComponent,
  ProductSupplyComponent,
  ProductDeliveryComponent,
} from '../../components/Dashboard/ReportingComponents';
import styles from './OperationsDashboard.module.css';

const { Title, Text } = Typography;

// ============================================================================
// OPERATIONS DASHBOARD
// ============================================================================

export const OperationsDashboard: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const { currentLocation, goBack } = useDashboardNavigation();

  if (!productId) {
    return (
      <div className={styles.emptyContainer}>
        <Empty
          description="No product selected"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        >
          <Button type="primary" icon={<ArrowLeftOutlined />} onClick={goBack}>
            Go Back
          </Button>
        </Empty>
      </div>
    );
  }

  const productName = currentLocation.productName || 'Product';

  return (
    <div className={styles.dashboard}>
      {/* Dashboard Header */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <SettingOutlined className={styles.headerIcon} />
          <div>
            <Title level={2} className={styles.title}>
              Operations - {productName}
            </Title>
            <Text className={styles.subtitle}>
              Demand generation, supply chain, and product delivery metrics
            </Text>
          </div>
        </div>
      </div>

      {/* Three Panel Layout */}
      <div className={styles.operationsGrid}>
        {/* Demand Panel - Top Left */}
        <div className={styles.demandPanel}>
          <div className={styles.panelHeader}>
            <FunnelPlotOutlined className={styles.panelIcon} />
            <Title level={4} className={styles.panelTitle}>Demand</Title>
          </div>
          <ProductDemandComponent
            artifactId={productId}
          />
        </div>

        {/* Supply Panel - Bottom Left */}
        <div className={styles.supplyPanel}>
          <div className={styles.panelHeader}>
            <InboxOutlined className={styles.panelIcon} />
            <Title level={4} className={styles.panelTitle}>Supply</Title>
          </div>
          <ProductSupplyComponent
            artifactId={productId}
          />
        </div>

        {/* Delivery Panel - Right Side */}
        <div className={styles.deliveryPanel}>
          <div className={styles.panelHeader}>
            <TruckOutlined className={styles.panelIcon} />
            <Title level={4} className={styles.panelTitle}>Delivery</Title>
          </div>
          <ProductDeliveryComponent
            artifactId={productId}
          />
        </div>
      </div>
    </div>
  );
};

export default OperationsDashboard;
